import * as React from 'react';
import * as I18n from 'i18n-js';
import track from 'react-tracking';

import {
  CSP,
} from '../../rql';
import CoreLink from '../../components/core_link';

import { get } from 'lodash';

import { IEventData, trackCSPClick } from '../../tracker';
import SanitizedRender from '../../components/sanitized_render';
import { prefilledListingFromCSP } from '../../url_helpers';

import {
  BrandMetaData,
  ConditionFilter,
  NameMetaData,
  PriceMetaData,
  DescriptionMetaData,
  ImageMetaData,
} from '../lib/metadata_helper';

export interface IProps {
  csp?: CSP;
  conditionFilter?: ConditionFilter;
  position?: number;
  hideMetadata?: boolean;
  shouldLinkToSellForm?: boolean;
  buyBoxActive?: boolean;
}

const FIRST_POSITION = 0;

@track((props: IProps): IEventData => {
  return {
    mParticleInteraction: (data: IEventData) => trackCSPClick(data, props.csp, { displayStyle: 'CspWideCard' }),
  };
})
export default class CSPWideCard extends React.Component<IProps, null> {
  public static defaultProps: Partial<IProps> = {
    position: FIRST_POSITION,
  };

  getBannerImage() {
    return null;
  }

  getBannerBackgroundStyle() {
    const url = this.getBannerImage();
    if (!url) return null;

    return { backgroundImage: `url(${url})` };
  }

  getCSPImageStyle() {
    const url = get(this.props.csp, 'image.source');
    if (!url) return null;

    return { backgroundImage: `url(${url})` };
  }

  priceTranslationKey(format) {
    if (this.props.shouldLinkToSellForm) {
      return `cms.cspFeature.pricing.selling.${format}`;
    }

    return `cms.cspFeature.pricing.buying.${format}`;
  }

  renderPrices() {
    const { csp } = this.props;
    const tags = {
      tagOpen: '<b>',
      tagClose: '</b>',
    };

    const { usedLowPrice, newLowPrice } = csp.inventory;
    const featuredListingPrice = this.props.buyBoxActive ? csp.featuredListing.listing?.price : null

    return (
      <ul className="csp-wide-card__prices">
        {usedLowPrice && this.props.conditionFilter !== 'new' &&
          <SanitizedRender
            className="csp-wide-card__price"
            htmlTag="li"
            html={I18n.t(
              this.priceTranslationKey('usedPriceFromWithTags'),
              { price: usedLowPrice.display, ...tags },
            )}
          />
        }
        {(featuredListingPrice || newLowPrice) && this.props.conditionFilter !== 'used' &&
          <SanitizedRender
            className="csp-wide-card__price"
            htmlTag="li"
            html={I18n.t(
              this.priceTranslationKey('newPriceFromWithTags'),
              { price: (featuredListingPrice || newLowPrice).display, ...tags },
            )}
          />
        }
      </ul>
    );
  }

  destinationPath() {
    if (this.props.shouldLinkToSellForm) {
      return prefilledListingFromCSP(this.props.csp.id);
    }

    if (this.props.conditionFilter === 'new') {
      return `${this.props.csp.webLink.path}#new_listings`;
    }

    if (this.props.conditionFilter === 'used') {
      return `${this.props.csp.webLink.path}#used_listings`;
    }

    return this.props.csp.webLink.path;
  }

  renderPlaceholder() {
    return (
      <div className="csp-wide-card csp-wide-card--placeholder">
        <div className="csp-wide-card__inner">
          <div className="csp-wide-card__content">
            <div className="csp-wide-card__content__img">
              <div className="csp-wide-card__content__img__inner" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderMetadata() {
    if (this.props.hideMetadata) return;

    return (
      <div>
        <BrandMetaData csp={this.props.csp} />
        <NameMetaData csp={this.props.csp} />
        <DescriptionMetaData csp={this.props.csp} />
        <ImageMetaData csp={this.props.csp} />
        <PriceMetaData
          csp={this.props.csp}
          conditionFilter={this.props.conditionFilter}
        />
      </div>
    );
  }

  render() {
    const { csp } = this.props;
    if (!csp) return this.renderPlaceholder();

    return (
      <article
        className="csp-wide-card"
      >
        <CoreLink
          className="csp-wide-card__inner"
          to={this.destinationPath()}
          entityId={this.props.csp.id}
          position={this.props.position}
        >
          {this.getBannerImage() &&
            <div
              className="csp-wide-card__banner-img"
              style={this.getBannerBackgroundStyle()}
            />
          }
          <div className="csp-wide-card__content">
            <div
              className="csp-wide-card__content__img"
            >
              <div
                className="csp-wide-card__content__img__inner"
                style={this.getCSPImageStyle()}
              />
            </div>
            <div className="csp-wide-card__content__details">
              <h4 className="csp-wide-card__content__title">
                {csp.title}
              </h4>
              {this.renderPrices()}
              {this.renderMetadata()}
            </div>
          </div>
        </CoreLink>
      </article>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/cms/components/csp_wide_card.tsx